<template>
  <li class="card-root" @click="handleClick">
    <span>{{ title }}</span>
  </li>
</template>

<script>
export default {
  props: {
    id: String,
    title: String,
  },

  methods: {
    handleClick() {
      this.$emit('click-on-card')
    },
  },
}
</script>

<style scoped lang="scss">
.card-root {
  padding: 20px;
  border-radius: 12px;
  background-color: var(--bg-3);
  cursor: pointer;

  &:hover {
    background-color: var(--bg-35);
  }
}
</style>
